import type { BrandCartAction } from "./BrandGroupHeader";

// LiveToolbar: how each brand lockup exposes its cart. Shared by the saved
// products and collection pages so the choice carries across both URLs.
export const CART_ACTION_PILL = 1;
export const CART_ACTION_BUTTON = 2;

const CART_ACTIONS: Record<number, BrandCartAction> = {
  [CART_ACTION_PILL]: "pill",
  [CART_ACTION_BUTTON]: "button",
};

export const cartActionForVariant = (variant: number): BrandCartAction =>
  CART_ACTIONS[variant] ?? "pill";

export const cartActionVariantGroup = (
  active: number,
  onChange: (variant: number) => void
) => ({
  title: "Brand cart action",
  queryKey: "cart-action",
  variants: [
    { variantNumber: CART_ACTION_PILL, label: "Cart pill" },
    { variantNumber: CART_ACTION_BUTTON, label: "View cart button" },
  ],
  active,
  onChange,
});
